import {
  BrandsFacebookF,
  BrandsGoogle,
  BrandsInstagram,
  BrandsLinkedin,
  BrandsSquareFacebook,
  BrandsTiktok,
  BrandsYoutube,
  SolidNewspaper
} from "@adfenix/icons";
import { ProgramService, TemplateService } from "@adfenix/types";
import { SVGProps } from "react";

export const channelIcons: Record<TemplateService.ChannelType, string> = {
  facebook: "facebook-f",
  twitter: "twitter",
  instagram: "instagram",
  displayAd: "newspaper",
  unknown: "",
  google: "google",
  linkedIn: "linkedin",
  tikTok: "",
  youTube: "youtube"
};

export const getSquaredIcon = (
  channel: ProgramService.ChannelType,
  props: SVGProps<SVGSVGElement> = {}
) => {
  switch (channel) {
    case "Facebook":
      return <BrandsSquareFacebook {...props} />;
    default:
      return getChannelIcon(channel, props);
  }
};

export const getChannelIcon = (
  channel: ProgramService.ChannelType,
  props: SVGProps<SVGSVGElement> = {}
) => {
  switch (channel) {
    case "Facebook":
      return <BrandsFacebookF {...props} />;
    case "Google":
      return <BrandsGoogle {...props} />;
    case "Instagram":
      return <BrandsInstagram {...props} />;
    case "LinkedIn":
      return <BrandsLinkedin {...props} />;
    case "TikTok":
      return <BrandsTiktok {...props} />;
    case "YouTube":
      return <BrandsYoutube {...props} />;
    case "DisplayAd":
      return <SolidNewspaper {...props} />;
    case "Unknown":
    default:
      return <></>;
  }
};
